import './PromoBanner.css'
import { Transition, TransitionChild } from '@headlessui/react'

export function PromoBanner({
  title,
  description,
  action
}: {
  title: string
  description: string
  action: React.ReactNode
}) {
  return (
    <Transition show appear>
      <TransitionChild
        enter="transition duration-300 ease-in-out"
        enterFrom="opacity-0 translate-y-4"
        enterTo="opacity-100 translate-y-0"
      >
        <div className="promo-banner">
          <div className="promo-banner-content">
            <h2 className="promo-banner-title">{title}</h2>
            <p className="promo-banner-description">{description}</p>
          </div>
          <div className="promo-banner-action">{action}</div>
        </div>
      </TransitionChild>
    </Transition>
  )
}
